import React from "react";
import "./CarLoader.css";

export default function CarLoader({
  overlay = true,
  title = "Submitting...",
  message = "Please wait while we process your listing",
  inline = false,
}) {
  if (inline) {
    return (
      <span className="car-loader-inline">
        <span className="car-loader-wheel" />
        <span>{title}</span>
      </span>
    );
  }

  const content = (
    <div className="car-loader-card">
      <div className="car-loader-icon">
        <div className="car-loader-wheel" />
      </div>
      <p className="car-loader-title">{title}</p>
      <p className="car-loader-text">{message}</p>
      <div className="car-loader-bar">
        <div className="car-loader-bar-fill" />
      </div>
    </div>
  );

  if (!overlay) return content;

  return <div className="car-loader-overlay">{content}</div>;
}
